import { personImage } from "../../utils/personImage";
// components/Visit/RepeatVisitorTable.jsx
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

export default function RepeatVisitorTable({ data, serverPagination }) {
  const navigate = useNavigate();
  const sortFields = { "รหัส": "user", "สถานะ": "type", "จำนวนครั้ง": "count", "ครั้งแรก": "first", "ล่าสุด": "last" };

  const customStyles = {
    rows: {
      style: {
        minHeight: "76px",
        fontSize: "14px",
        color: "#334155",
        borderBottomColor: "#f1f5f9",
      },
    },
    headCells: {
      style: {
        fontSize: "12px",
        fontWeight: 600,
        color: "#64748b",
      },
    },
  };

  const columns = [
    {
      name: "รหัส",
      selector: (row) => row.ulucu_user_id,
      sortable: true,
      cell: (row) => (
        <span
          className="cursor-pointer rounded-lg bg-teal-50 px-2 py-1 font-mono text-xs font-semibold text-teal-700 transition hover:bg-teal-100"
          onClick={() =>
            row.visitor_type !== "unknown"
              ? navigate(`/member/${row.ulucu_user_id}`)
              : navigate(`/visit-log/${row.ulucu_user_id}`)
          }
        >
          #{row.ulucu_user_id.slice(-6)}
        </span>
      ),
    },

    {
      name: "รูป",
      width: "100px",
      cell: (row) => {
        // let imgSrc = row.arrive_image_url;
        //   row.sex === "1" ? "/male-ai.jpg" : "/female-ai.png";
        // imgSrc = row.arrive_image_url;
        let imgSrc = "";
        const age = parseInt(row.age); // กันพลาด แปลงเป็นตัวเลขก่อน

        if (row.sex === "1") {
          // 👨 ผู้ชาย
          if (age >= 19 && age <= 25) {
            imgSrc = "/M-19-25.jpg";
          } else if (age >= 26 && age <= 35) {
            imgSrc = "/M-26-35.jpg";
          } else if (age >= 36 && age <= 45) {
            imgSrc = "/M-36-45.jpg";
          } else if (age >= 46) {
            imgSrc = "/M-46-60.jpg";
          } else {
            imgSrc = "/M-19-25.jpg";
          }
        } else {
          // 👩 ผู้หญิง
          if (age >= 19 && age <= 25) {
            imgSrc = "/FM-19-25.jpg";
          } else if (age >= 26 && age <= 35) {
            imgSrc = "/FM-26-35.jpg";
          } else if (age >= 36 && age <= 45) {
            imgSrc = "/FM-36-45.jpg";
          } else if (age >= 46) {
            imgSrc = "/FM-36-45.jpg";
          } else {
            imgSrc = "/FM-19-25.jpg";
          }
        }

        imgSrc = personImage(row.arrive_image_url, row);

        return (
          <img
            src={imgSrc}
            className="h-14 w-14 rounded-xl border border-slate-200 object-cover shadow-sm"
            alt="รูปผู้เข้าใช้บริการซ้ำ"
          />
        );
      },
    },

    {
      name: "สถานะ",
      sortable: true,
      cell: (row) => (
        <span
          className={`
            px-3 py-1 rounded-full text-xs font-medium
            ${
              row.visitor_type === "VIP" || row.visitor_type === "ลูกค้า VIP"
                ? "bg-yellow-100 text-yellow-700"
                : row.visitor_type === "พนักงาน"
                ? "bg-blue-100 text-blue-700"
                : "bg-gray-100 text-gray-600"
            }
          `}
        >
          {row.visitor_type}
        </span>
      ),
    },

    {
      name: "จำนวนครั้ง",
      selector: (row) => row.count,
      sortable: true,
      right: true,
      cell: (row) => (
        <span className="font-bold text-emerald-600 text-base">
          {row.count}
        </span>
      ),
    },

    {
      name: "ครั้งแรก",
      selector: (row) => row.first_visit,
      sortable: true,
    },

    {
      name: "ล่าสุด",
      selector: (row) => row.last_visit,
      sortable: true,
    },
  ];

  return (
    <div className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm">
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <div>
          <h2 className="font-semibold text-slate-900">ผู้เข้าใช้บริการซ้ำ</h2>
          <p className="mt-0.5 text-xs text-slate-500">ผู้ที่ถูกตรวจพบมากกว่าหนึ่งครั้งในช่วงเวลาที่เลือก</p>
        </div>
        <span className="rounded-full bg-teal-50 px-3 py-1 text-xs font-medium text-teal-700">{serverPagination?.total ?? data.length} คน</span>
      </div>

      <DataTable
        columns={serverPagination ? columns.map(column => ({ ...column, id: sortFields[column.name] || column.name, sortField: sortFields[column.name] })) : columns}
        data={data}
        pagination
        paginationPerPage={10}
        paginationRowsPerPageOptions={[10, 20, 50]}
        {...(serverPagination ? {
          paginationServer: true, paginationTotalRows: serverPagination.total,
          paginationPerPage: serverPagination.pageSize, paginationDefaultPage: serverPagination.page,
          paginationResetDefaultPage: serverPagination.page === 1,
          onChangePage: serverPagination.onPage, onChangeRowsPerPage: serverPagination.onPageSize,
          progressPending: serverPagination.loading, sortServer: true, onSort: serverPagination.onSort,
          defaultSortFieldId: serverPagination.sortBy, defaultSortAsc: serverPagination.sortDirection === "asc",
        } : {})}
        highlightOnHover
        responsive
        persistTableHead
        noDataComponent="ไม่พบลูกค้าที่เข้ามาซ้ำ"
        customStyles={customStyles}
      />
    </div>
  );
}
